import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Conformation from "../Modal/Confirmation";
import Slide from "@mui/material/Slide";
import Modal from "@mui/material/Modal";
import PdfViewModal from "../Modal/PdfViewModal";
import { readFile } from "../../Js/Common";

const LeafCard = (props) => {
  //Hooks
  const classes = useStyles();
  const containerRef = useRef();
  const { breadcrumb } = useSelector((state) => state.common);
  let coursePermissions = useSelector(
    (state) => state.defs.siteConfig.products[0]["coursePermissions"]
  );

  const [open, setOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [lessonLearning, setLessonLearning] = useState(false);
  const [lessonLearningFile, setLessonLearningFile] = useState(null);

  // Load Dynamic Image
  const loadImage = (title) => {
    if (title.toLowerCase().includes("learn")) {
      return require('../../assets/Learning.png');
    } else if (title.toLowerCase().includes("practice")) {
      return require('../../assets/he_sitting_with_notebook 1.png');
    } else if (title.toLowerCase().includes("challenge")) {
      return require('../../assets/Challenge.png');
    } else {
      return require('../../assets/Learning.png');
    }
  };

  useEffect(async () => {
    getbreadcrumPath();
  }, []);

  const getbreadcrumPath = async () => {
    let str = breadcrumb
      .split("|")
      .map((val) => {
        return val.trim();
      })
      .join("_")
      .split(":")
      .join("_")
      .split(" ")
      .join("_");

    let fname = str.replaceAll(">", "_");
    fname = fname.replaceAll("?", "_");
    console.log("file name: ", fname);
    setLessonLearningFile(`${fname}.pdf`);
    let res = await readFile(`${fname}.pdf`, "/public/manuals");

    if (res.response == true) {
      setLessonLearning(true);
    }

    //return str;
  };

  const handleOpenPdf = () => setModalVisible(true);
  const handleClosePdf = () => setModalVisible(false);

  return (
    <Box>
      <Card
        className={classes.card}
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <Box sx={{ flex: "1" }}>
          <CardContent
            sx={{
              paddingTop: "1px !important",
              paddingBottom: "1px !important",
              height: "26vh",
              overflow: "auto",
            }}
          >
            <Typography
              component="div"
              sx={{
                color: "#ffffffff",
                fontWeight: "bold",
                fontSize: "1.2rem",
                "@media (min-width: 1636px)": {
                  fontSize: "2rem",
                },
              }}
            >
              {props.title}
            </Typography>
            {props.data &&
              props.data
                .filter((val) => {
                  return (
                    coursePermissions &&
                    coursePermissions.indexOf(val.value) == -1
                  );
                })
                .map((obj, index) => {
                  return (
                    <Box sx={{ width: "100%" }} key={"leafNode_" + index}>
                      <List sx={{ py: 0.7 }}>
                        <ListItem
                          disablePadding
                          onClick={() => props.press(obj)}
                          sx={{ backgroundColor: "#a4dbffff"}}
                          secondaryAction={
                            <IconButton
                              edge="end"
                              au6ria-label="comments"
                              sx={{ color: "#FFFFFF" }}
                            >
                              <KeyboardArrowRightIcon
                                sx={{
                                  fontSize: "1.2rem",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2rem",
                                  },
                                }}
                              />
                            </IconButton>
                          }
                        >
                          <ListItemButton
                            sx={{
                              borderRadius: 15,
                              paddingTop: "0.2rem",
                              paddingBottom: "0.2rem",
                            }}
                          >
                            <ListItemText>
                              <Typography
                                sx={{
                                  color: "#5f5600ff",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                  },
                                }}
                              >
                                {obj.value}
                              </Typography>
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </List>
                    </Box>
                  );
                })}

            {/*  add by Jaimin below code */}
            {/* {props.title &&
              props.title.toLowerCase().includes("learn") &&
              lessonLearning && (
                <Box sx={{ width: "100%" }} key={"tutorial"}>
                  <List sx={{ py: 0.7 }}>
                    <ListItem
                      disablePadding
                      onClick={() => {
                        handleOpenPdf();
                      }}
                      sx={{ backgroundColor: "#a4dbffff"}}
                      secondaryAction={
                        <IconButton edge="end" sx={{ color: "#FFFFFF" }}>
                          <KeyboardArrowRightIcon
                            sx={{
                              fontSize: "1.2rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        sx={{
                          borderRadius: 15,
                          paddingTop: "0.2rem",
                          paddingBottom: "0.2rem",
                        }}
                      >
                        <ListItemText>
                          <Typography
                            sx={{
                              color: "#5f5600ff",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            {"Lesson Plan"}
                          </Typography>
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Box>
              )} */}
          </CardContent>
        </Box>
      </Card>
      <Conformation
        visibility={open}
        toggle={(flag) => {
          setOpen(flag);
        }}
      />

      <Modal
        open={modalVisible}
        onClose={() => {
          handleClosePdf();
        }}
        ref={containerRef}
      >
        <Box className={[classes.scrollBar, classes.Modal]}>
          <PdfViewModal filename={lessonLearningFile} />
        </Box>
      </Modal>
    </Box>
  );
};

const useStyles = makeStyles({
  card: {
     background: "linear-gradient(to bottom, rgba(30,87,153,1) 0%,rgba(41,137,216,1) 50%,rgba(32,124,202,1) 51%,rgba(125,185,232,1) 100%)",
    paddingTop: 15,
    paddingLeft: 5,
    paddingRight: 5,
    width: "18em",
    height: "24vh",
    "@media (min-width: 1636px)": {
      width: "33em",
      height: "27vh",
    },
  },

  Modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    height: "90vh",
    overflow: "auto",
    backgroundColor: "#089bb4ff",
    boxShadow: 24,
    color: "#FFFFFF",
    padding: 0,
    "@media (min-width: 1636px)": {
      width: 1024,
    },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
   },
});

export default LeafCard;
